import classNames from 'classnames';
import { bool, func, object, shape, string } from 'prop-types';
import React from 'react';
import { ExpandableInput } from '@eika/expandable-input';
import { Input } from '@eika/input';
import { RadioButtons } from '@eika/radio-button';
import connect from '../../helper/connect';
import getLabel from '../labels';
import { validateFatcaCrsV2Confirmation, validateFatcaV2TaxNumber } from '../../../validator';
import ErrorMessage from '../../errormessage';

const FatcaV2 = ({ onChange, question, ekstratekster, context, prefilled }) => {
    const setShowTaxNumberMissing = (value) => {
        onChange(question.id, { showTaxNumberMissing: value === '1', taxNumber: '', taxNumberMissing: '' });
    };

    const setTaxRelationValidOrEnded = (value) => {
        onChange(question.id, { taxRelationValid: value === '0', taxRelationEnded: value === '1' });
    };

    const setTaxNumberMissing = (event) => {
        onChange(question.id, { taxNumberMissing: event.target.value, taxNumber: '' });
    };

    const setTaxNumber = (event) => {
        onChange(question.id, { taxNumber: event.target.value, taxNumberMissing: '' });
    };

    const setTaxRelationComment = (event) => {
        onChange(question.id, { taxRelationComment: event.target.value });
    };

    const options = [
        { value: 0, label: 'Ja' },
        { value: 1, label: 'Nei' },
    ];

    const getSelectedOption = () => {
        if (question.showTaxNumberMissing !== undefined && question.showTaxNumberMissing !== '') {
            return question.showTaxNumberMissing ? 1 : 0;
        }
        return undefined;
    };

    const getSelectedStillValidOption = () => {
        if (question.taxRelationValid) {
            return 0;
        }
        if (question.taxRelationEnded) {
            return 1;
        }
        return undefined;
    };

    const hasSubmitted = context.getHasSubmitted();
    const taxNumberError = hasSubmitted && !validateFatcaV2TaxNumber(question);
    const confirmationError = hasSubmitted && !validateFatcaCrsV2Confirmation(question);
    const validTaxNumberResponseMissingError = hasSubmitted && getSelectedOption() === undefined;

    return (
        <div>
            <div className="radioknobs tax-relation">
                <RadioButtons
                    onChange={setShowTaxNumberMissing}
                    options={options}
                    selectedOption={getSelectedOption()}
                    horizontal={options.length < 3}
                    // TODO: Should be part of the form from back-end?
                    label="Har du amerikansk identifikasjonsnummer (TIN)?"
                />
                {validTaxNumberResponseMissingError && <ErrorMessage text="Velg Ja eller Nei" />}
            </div>

            {(question.showTaxNumberMissing === false || question.taxNumber) && (
                <div className={classNames({ 'has-error error': taxNumberError })}>
                    <h2 className="skjema-input-question">{getLabel(ekstratekster, 'fatca_tax_number')}</h2>
                    <Input
                        type="text"
                        onChange={setTaxNumber}
                        name="taxNumber"
                        value={question.taxNumber}
                        id={`taxNumber_${question.id}`}
                        className="form-control"
                        disabled={question.showTaxNumberMissing}
                    />
                    {taxNumberError && <ErrorMessage text={getLabel(ekstratekster, 'fatca_tax_number_instruction')} />}
                </div>
            )}

            {question.showTaxNumberMissing === true && (
                <div className={classNames({ 'has-error error': taxNumberError }, 'margin-top-medium')}>
                    {/* <h2 className="skjema-input-question">{getLabel(ekstratekster, 'fatca_reason')}</h2> */}
                    {/* TODO: Text should come from back-end? */}
                    <h2 className="skjema-input-question">
                        Oppgi årsak for at du mangler amerikansk identifikasjonsnummer (TIN)
                    </h2>
                    <Input
                        onChange={setTaxNumberMissing}
                        type="text"
                        name="taxNumberMissing"
                        id={`taxNumberMissing_${question.id}`}
                        value={question.taxNumberMissing}
                        className="form-control fatca-taxNumberMissing"
                    />
                    {taxNumberError && (
                        <ErrorMessage text={getLabel(ekstratekster, 'fatca_tax_number_missing_instruction')} />
                    )}
                </div>
            )}

            {prefilled && (
                <div
                    className={classNames('skjema-input-field', 'skjema-radio', {
                        'has-error error': confirmationError,
                    })}
                >
                    <div
                        className={classNames('radioknobs', 'extra-large-margin-top', {
                            'tax-relation': !confirmationError,
                        })}
                    >
                        <RadioButtons
                            onChange={setTaxRelationValidOrEnded}
                            options={options}
                            selectedOption={getSelectedStillValidOption()}
                            horizontal={options.length < 3}
                            // TODO: Should be part of the form from back-end?
                            label="Er denne skatterelasjonen fortsatt gjeldende?"
                        />
                    </div>

                    {confirmationError && <ErrorMessage text={getLabel(ekstratekster, 'fatca_confirm_instruction')} />}

                    {question.taxRelationEnded && (
                        <div className="extra-margin-top">
                            {/* <h2 className="skjema-input-question">{getLabel(ekstratekster, 'fatca_comment')}</h2> */}
                            {/* TODO: Text should come from back-end? */}
                            <h2 className="skjema-input-question">Oppgi årsak for opphørt skatterelasjon</h2>
                            <ExpandableInput
                                onChange={setTaxRelationComment}
                                name="comment"
                                id={`comment_${question.id}`}
                                value={question.taxRelationComment}
                                className="form-control"
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

FatcaV2.propTypes = {
    question: object.isRequired,
    ekstratekster: shape({
        fatca_tax_number: string,
        fatca_tax_number_instruction: string,
        fatca_tax_number_missing: string,
        fatca_reason: string,
        fatca_tax_number_missing_instruction: string,
        fatca_valid: string,
        fatca_ended: string,
        fatca_confirm_instruction: string,
        fatca_comment: string,
        fatca_instructions: string,
    }).isRequired,
    onChange: func,
    context: object,
    prefilled: bool,
};

export default connect(FatcaV2);
